export class Product {
    productCode: string;
    productDetails: ProductDetails;
    constructor() {
        this.productCode = "";
        this.productDetails = new ProductDetails();
    }

}
export class ProductDetails {
    metaData: MetaData;
    rates: Array<Rates>;
    constructor() {
        this.metaData = new MetaData();
        this.rates = new Array<Rates>();
        this.rates.push(new Rates());
    }
}

export class MetaData {
    longName: Array<LongName>;
    term: number;
    rateType: string;
    constructor() {
        this.longName = new Array<LongName>();
        this.longName.push(new LongName("en"));
        this.longName.push(new LongName("fr"))
        this.term = 0;
        this.rateType = "";
    }

}
export class Rates {
    rate: Array<Rate>;
    constructor() {
        this.rate = new Array<Rate>();
        this.rate.push(new Rate());
        this.rate.push(new Rate());
    }
}
export class Rate {
    rateValue: number;
    rateTypeID: number;
    discount: number;
    arp: number;
    prodCode: string;
    constructor() {
        this.rateValue = 0;
        this.rateTypeID = 0;
        this.discount = 0;
        this.arp = 0;
        this.prodCode = "";
    }
}

export class LongName {
    name: string;
    language: string;
    constructor(lan: string) {
        this.name = "";
        this.language = lan;

    }
}